import { default as SecurityProvider } from './SecurityProvider'

function plugin (app, opts) {
	if (!opts.router) {
		throw new Error('You must supply a router instance in the options.')
	}
	if (!opts.store) {
		throw new Error('You must supply a store instance in the option')
	}
	const sp = new SecurityProvider(opts.router, opts.store)
	opts.router.beforeEach((to, from, next) => sp.resolve(to, from, next))
}

export default plugin
